/* eslint-disable @typescript-eslint/no-unused-vars */
// MenuData.ts
import { ReactComponent as HomeSvg } from "@assets/Icons/Icon.svg";
import { ReactComponent as IconReflector } from "@assets/Icons/IconReflector.svg";

// Kontrol menu icons
import { ReactComponent as ServerSVG } from "@assets/Icons/IconServer.svg";
import { ReactComponent as BackboneSVG } from "@assets/Icons/IconBackbone.svg";
import { ReactComponent as ConnectivityKontrolSVG } from "@assets/Icons/IconConnectivityKontrol.svg";
import { ReactComponent as DataInterconnectSVG } from "@assets/Icons/IconDataInterconnect.svg";
import { ReactComponent as InternetSVG } from "@assets/Icons/IconInternet.svg";
import { ReactComponent as IconFirewall } from "@assets/Icons/IconFwaas.svg";

// Settings icons
// import { ReactComponent as BillingSVG } from "@assets/Icons/IconBilling.svg";
// import { ReactComponent as LogsSVG } from "@assets/Icons/IconLogs.svg";
import { ReactComponent as SupportSVG } from "@assets/Icons/IconSupport.svg";
import { ReactComponent as Quotation } from "@assets/Icons/IconQuotation.svg";
import { ReactComponent as ReportSVG } from "@assets/Icons/IconReport.svg";
import { ReactComponent as IconAccount } from "@assets/Icons/IconAccount.svg";
import { ReactComponent as IconLicense } from "@assets/Icons/Icon_FileSign.svg";
import { ReactComponent as IconEyeSmall } from "@assets/Icons/SmallEye.svg";


// === CTX Reflector V2 Menu Items ===
// import { settingsItems } from "./MenuData";

export interface MenuItem {
  label: string;
  id?: string;
  path?: string;
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  children?: MenuItem[];
  badge?: string;
  customAction?: () => void;
}

export const mainItems: MenuItem[] = [
  { label: "Home", id: "home", path: "/", Icon: HomeSvg },
];

// Aquí quitamos el "Management" de dentro de CTX Reflector.
// Dejamos "Main Status" y "L3 Overview" como hijos directos.
export const serviceItems: MenuItem[] = [
  {
    label: "CTX Hub",
    id: "ctx-hub",
    children: [
      { label: "Data Usage", id: "ctx-hub-status", path: "/ctxhub/status" },
    ],
  },
  {
    label: "Port",
    id: "kontrol-port",
    path: "/kontrol/port",
    Icon: ServerSVG,
  },
  {
    label: "Internet Connection",
    id: "kontrol-ipx",
    path: "/kontrol/ipx",
    Icon: InternetSVG,
  },
  {
    label: "Data Center Interconnect",
    id: "kontrol-dc",
    path: "/kontrol/datacenter",
    Icon: DataInterconnectSVG,
  },
  {
    label: "Cloud Connectivity",
    id: "kontrol-cc",
    path: "/kontrol/cloud-connectivity",
    Icon: ConnectivityKontrolSVG,
  },
  {
    label: "Backbone",
    id: "kontrol-backbone",
    path: "/kontrol/backbone",
    Icon: BackboneSVG,
  },
  {
    label: "FWaaS",
    id: "fwaas-root",
    Icon: IconFirewall,
    path: "/kontrol/fwaas",
  },
  {
    label: "CTX Reflector",
    id: "ctx-reflector",
    Icon: IconReflector,
    children: [
      
      {
        label: "L3 Overview",
        id: "reflector-l3overview",
        children: [
          {
            label: "BGP Overview",
            id: "reflector-l3overview-bgp",
            path: "/reflector/l3overview/bgp",
          },
          {
            label: "Logs Detail",
            id: "reflector-l3overview-logs",
            path: "/reflector/l3overview/logs",
          },
        ],
      },
      // <-- Ya NO incluimos "Management" aquí
    ],
  },
  // {
  //   label: "Quotations",
  //   id: "quotations",
  //   Icon: Quotation,
  //   path: "/kontrol/quotations",
  // },
];

// NUEVO: sección "Management" top-level
export const managementItems: MenuItem[] = [
  {
    label: "Licensing",
    id: "reflector-management-licensing",
    path: "/reflector/management/licensing",
  },
  {
    label: "Instances",
    id: "reflector-management-instances",
    children: [
      {
        label: "Licensed",
        id: "reflector-instances-licensed",
        path: "/reflector/management/instances/licensed",
      },
      {
        label: "Unlicensed",
        id: "reflector-instances-unlicensed",
        path: "/reflector/management/instances/unlicensed",
      },
      {
        label: "High Availability",
        id: "reflector-instances-highavailability",
        path: "/reflector/management/instances/highavailability",
      },
      {
        label: "Health Check",
        id: "reflector-instances-healthcheck",
        path: "/reflector/management/instances/healthcheck",
      },
      {
        label: "Syslog",
        id: "reflector-instances-syslog",
        path: "/reflector/management/instances/syslog",
      },
    ],
  },
  {
    label: "BGP",
    id: "reflector-management-bgp",
    children: [
      {
        label: "Neighbors",
        id: "reflector-bgp-management",
        path: "/reflector/management/bgp/neighbors",
      },
      {
        label: "Status",
        id: "reflector-bgp-status",
        path: "/reflector/management/bgp/status",
      },
    ],
  },
];

// NUEVO: sección "Settings" top-level (lo que antes era `additionalItems`).
export const settingsItems: MenuItem[] = [
  {
    label: "Account",
    id: "account-management",
    Icon: IconAccount,
    children: [
      {
        label: "Users",
        id: "account-management-users",
        path: "/account/users",
      },
      {
        label: "Customers",
        id: "account-management-customers",
        path: "/account/customers",
      },
      // {
      //   label: "Notifications",
      //   id: "account-management-notifications",
      //   path: "/kontrol/notifications-management",
      //   badge: "Beta",
      // },
    ],
  },
  {
    label: "Support",
    id: "support-root",
    Icon: SupportSVG,
    children: [
      // {
      //   label: "Customer Care",
      //   id: "customerCare-root",
      //   Icon: SupportSVG,
      //   customAction: () => window.Intercom?.("show"),
      // },
      {
        label: "Technical Support",
        id: "request-root",
        path: "/support/request",
        Icon: ReportSVG 
      },
    ],
  },
  // { label: "Logs",
  //   id: "logs-root",
  //   // path: "/logs",
  //   Icon: LogsSVG },
  // { label: "Billing",
  //   id: "billing-root",
  //   // path: "/billing",
  //   Icon: BillingSVG },
  // {
  //   label: "Settings",
  //   id: "settings-root",
  //   // path: "/settings",
  //   Icon: IconSettings,
  // },
];

const settingsItemsForReflectorV2 = settingsItems.map(section => {
  // target only the Account section
  if (section.id === "account-management" && section.children) {
    return {
      ...section,
      children: section.children.filter(
        child => child.id !== "account-management-notifications"
      ),
    };
  }
  return section;
});

// === CTX Reflector V2 Menu Items ===
export const reflectorV2MenuItems: MenuItem[] = [
  { label: "Overview", id: "reflector-v2-overview", path: "/reflector-v2/overview", Icon: HomeSvg },
  {
    label: "Management",
    id: "reflector-v2-management",
    children: [
      { label: "Reflectors", id: "reflector-v2-bgp-reflectors", path: "/reflector-v2/management/bgp-reflectors" , Icon: ServerSVG},
      { label: "BGP Visibility", id: "reflector-v2-bgp-visibility", path: "/reflector-v2/management/bgp-visibility", Icon: IconEyeSmall },
      { label: "Licensing", id: "reflector-v2-licensing", path: "/reflector-v2/management/licensing" , Icon: IconLicense},
    ],
  },
  {
    label: "Settings",
    id: "reflector-v2-settings",
    children: [...settingsItemsForReflectorV2],
  },
];
